import { render, staticRenderFns } from "./ItemFavoriteButton.vue?vue&type=template&id=c7f53be2"
import script from "./ItemFavoriteButton.vue?vue&type=script&lang=js"
export * from "./ItemFavoriteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports